import {
	faAddressCard,
	faPhone,
	faClock,
	faEnvelope,
	faVideo,
	faPeopleArrows,
} from "@fortawesome/free-solid-svg-icons";
import { getAddressArray } from "$lib/utilities/getAddressArray";
import { translate } from "./translate.js";
import { formattedPhone } from "cando-util";

export const getLocationServices = (data, location, lang) => {
	const settings = data?.content?.settings || {};
	const addressIcon = settings?.['App Settings']?.addressIcon?.value?.icon || faAddressCard;
	const phoneIcon = settings?.['App Settings']?.phoneIcon?.value?.icon || faPhone;
	const hoursIcon = settings?.['App Settings']?.hoursIcon?.value?.icon || faClock;
	const emailIcon = settings?.['App Settings']?.emailIcon?.value?.icon || faEnvelope;
	const videoIcon = settings?.['App Settings']?.videoIcon?.value?.icon || faVideo;
	const inPersonIcon = settings?.['App Settings']?.inPersonIcon?.value?.icon || faPeopleArrows;

	const getPhoneLink = p => {
		const formatted_phone = formattedPhone(p, false);
		return `<a href="tel: ${formatted_phone}" target="_blank" class="link hover-ripple hover:cursor-pointer inline-block rounded-xl text-primary transition-all duration-300 ease-in-out">${formatted_phone}</a>`;
	};

	const labels = Object.keys(settings?.['App Settings']?.labels?.value || {}).reduce(
		(a, v) => ({
			...a,
			[v]: translate(settings?.['App Settings']?.labels?.value?.[v], lang),
		}),
		{},
	);

	return [
		...(location?.formattedAddress?.value || getAddressArray(location).join("\n\n")
			? [
				{
					icon: addressIcon,
					title: labels?.address,
					content: [location?.formattedAddress?.value ? location?.formattedAddress?.value : getAddressArray(location).join("\n\n")],
					isIdentifier: true
				},
			]
			: []),
		...(location?.["response-nationalPhoneNumber"]?.value
			? [
				{
					icon: phoneIcon,
					title: labels?.phone,
					content: [
						getPhoneLink(location?.["response-nationalPhoneNumber"]
							?.value || ""),
					],
					isIdentifier: true
				},
			]
			: []),
		...(location?.["nationalPhoneNumber"]?.value
			? [
				{
					icon: phoneIcon,
					title: labels?.phone,
					content: [
						getPhoneLink(location?.["nationalPhoneNumber"]
							?.value || ""),
					],
					isIdentifier: true
				},
			]
			: []),
		...(location?.email?.value
			? [
				{
					icon: emailIcon,
					title: labels?.email,
					content: [location?.email?.value || ""],
					isIdentifier: true
				},
			]
			: []),
		...(location?.hoursSimplified?.value
			? [
				{
					icon: hoursIcon,
					title: labels?.hours,
					content: [
						translate(location?.hoursSimplified, lang),
					],
				},
			]
			: []),
		...(location?.hoursVideo?.value
			? [
				{
					icon: videoIcon,
					title: labels?.video,
					content: [
						translate(location?.hoursVideo, lang),
					],
				},
			]
			: []),
		...(location?.hoursInPerson?.value
			? [
				{
					icon: inPersonIcon,
					title: labels?.inPerson,
					content: [
						translate(location?.hoursInPerson, lang),
					],
				},
			]
			: []),
	];
};
